export default class ToolMath {
    //單例模式
    static _instance;
    static get Instance() {
        if (this._instance == null) {
            this._instance = new ToolMath();
        }

        return this._instance;
    }

    /**取得顯示時間 00:00 */
    getDisplayTime(displayTime) {
        const tempTotalTime = Math.floor(displayTime);
        let tempMinute = Math.floor(tempTotalTime / 60).toString();
        let tempSecond = (tempTotalTime % 60).toString();

        tempMinute = this.stringAddZero(tempMinute);
        tempSecond = this.stringAddZero(tempSecond);
        return `${tempMinute}:${tempSecond}`;
    }

    /**二位數補零 */
    stringAddZero(value) {
        if (value.length < 2)
            value = '0' + value;
        return value;
    }
}